import { ContractPolicy } from "@meditect/medibase-api-client";

export const formatContractPolicyTitle = (policy: ContractPolicy): string => {
  const isBeneficiary = policy?.beneficiaryId !== policy?.contract.owner.id;

  return `${policy?.contract.insurer.name} (${
    isBeneficiary ? "par relation" : "directe"
  }) - ${policy.coverage}%`;
};
